import React, { useEffect } from 'react';

import { SignupForm } from '../../forms';
import { useMainLayoutContext } from '../../layouts/MainLayoutContext';

export const SignupPage = () => {
  const { updateContextValue } = useMainLayoutContext();

  useEffect(() => {
    updateContextValue({ title: 'Online profile' });

    return () => {
      updateContextValue({ title: undefined });
    };
    // eslint-disable-next-line
  }, []);

  return <SignupForm />;
};
